import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getCommentModule } from '../module';
export const CommentReduxModule = ()=>{
    return /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getCommentModule()
        ]
    });
};
CommentReduxModule.displayName = 'CommentReduxModule';
export default CommentReduxModule;

//# sourceMappingURL=CommentReduxModule.js.map